import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';

export function RequiredDocumentReason({
  actions,
  resolved = false,
}: {
  actions?: ButtonPropsWithLabel[];
  resolved?: boolean;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.waiverRequired.title')}
      message={t('blockingReasons.waiverRequired.message')}
      actions={resolved ? undefined : actions}
      color={resolved ? 'success' : 'error'}
    />
  );
}
